import React from 'react'
import scrollSnapPolyfill from 'css-scroll-snap-polyfill'
import { ArticleTypes, BasketTypes } from 'types'
import { CheckIcon } from 'assets/icons'

import './Picker.scss'

interface Props {
    activeId: string,
    listItems: ArticleTypes.Article[],
    basket?: BasketTypes.Item[],
    onUpdate: Function
}

const LIST_ITEM_HEIGHT = 36 // px
let TIMER_SCROLL: NodeJS.Timer

export default class Picker extends React.Component<Props> {

    public setSelectedItemState = (item: string) => {
        this.props.onUpdate(item)
    }

    public setActiveId = ( id: string ) => {
        const $wrapper =  document.querySelector('#picker .wrapper')
        const itemIndex = this.props.listItems.findIndex((val: ArticleTypes.Article) => val.id === id )
        if ($wrapper) {
            $wrapper.scrollTop = (itemIndex * LIST_ITEM_HEIGHT)
        }
    }

    public highlightactiveId = () => {
        const $wrapper =  document.querySelector('#picker .wrapper')

        if ($wrapper) {

            const $listItems = $wrapper.querySelectorAll('li[data-id]')

            Array.from($listItems).map( ($elem: HTMLElement, index: number) => {
                if ($wrapper) {
                    let offsetTop = $elem.getBoundingClientRect().top - $wrapper.getBoundingClientRect().top
                    let windowHeight = $wrapper.clientHeight
                    let itemMinOffset = (windowHeight - LIST_ITEM_HEIGHT) - LIST_ITEM_HEIGHT

                    if ( offsetTop >= itemMinOffset && offsetTop <= (itemMinOffset + LIST_ITEM_HEIGHT) - 1) {
                        if (!$elem.classList.contains('active')) {
                            $elem.classList.add('active')
                            const item: string = $elem.dataset.id ? $elem.dataset.id : this.props.activeId
                            this.setSelectedItemState(item)
                        }
                    } else {
                        $elem.classList.remove('active')
                    }
                }
            })
        }
    }

    public handleScroll = (event: any) => {
        if (TIMER_SCROLL) {
            clearTimeout(TIMER_SCROLL)
        }
        TIMER_SCROLL = global.setTimeout( () => this.highlightactiveId(), 100)
    }

    public handleClick = (item: string) => {
        this.setActiveId(item)
    }

    public componentDidMount () {
        scrollSnapPolyfill()
        this.setActiveId(this.props.activeId)
        this.highlightactiveId()
    }

    public render() {

        const { basket, listItems } = this.props

        return(
            <div id="picker">
                <div className="scroll-overflow">
                    <ul className="wrapper" onScroll={this.handleScroll}>
                        <li />
                            {listItems.map((item: ArticleTypes.Article, index: number) =>
                                <li
                                    data-id={item.id}
                                    key={index}
                                    onClick={(event) => this.handleClick(item.id)}
                                >
                                    { basket &&
                                        <i
                                            className={basket.findIndex((val: BasketTypes.Item ) =>
                                            val.id === item.id) > -1 ? 'active-icon active' : 'active-icon'}
                                        >
                                            <CheckIcon/>
                                        </i>
                                    }
                                    {item.name}
                                </li>
                            )}
                        <li />
                    </ul>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Picker/index.tsx